import React, { useState } from 'react';
import Header from '../utils/Header'
import Footer from '../utils/Footer'
import { useSearchParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import Cancelar from "../../assets/Cancelar.png";
import messageServices from '../../services/messageServices';

const ContactForm = () => {

    const [searchParams] = useSearchParams();
    const [name, setName] = useState(searchParams.get("name"));
    const [email, setEmail] = useState(searchParams.get("email"));
    const [message, setMessage] = useState(searchParams.get("message"));
    const [phone, setPhone] = useState(searchParams.get("phone"));
    const [sendInfo, setSendInfo] = useState(false);


    const handleValidation = () => {
        if (!name.trim()) {
            Swal.fire({
                imageUrl: Cancelar,
                imageWidth: 80,
                imageHeight: 80,
                title: 'Nombre requerido',
                text: 'Por favor, ingresa tu nombre.',
                timer: 5000,
                timerProgressBar: true,
                showConfirmButton: true,
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#1F4F51',
                customClass: {
                    confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",
                },
            });
            return false;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email.trim() || !emailRegex.test(email)) {
            Swal.fire({
                imageUrl: Cancelar,
                imageWidth: 80,
                imageHeight: 80,
                title: 'Correo electrónico inválido',
                text: 'Por favor, ingresa un correo electrónico válido.',
                timer: 5000,
                timerProgressBar: true,
                showConfirmButton: true,
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#1F4F51',
                customClass: {
                    confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",
                },
            });
            return false;
        }

        if (phone.length < 10) {
            Swal.fire({
                imageUrl: Cancelar,
                imageWidth: 80,
                imageHeight: 80,
                title: 'Número de teléfono requerido',
                text: 'Por favor, ingresa un número de teléfono válido - minimo 10 digitos.',
                timer: 5000,
                timerProgressBar: true,
                showConfirmButton: true,
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#1F4F51',
                customClass: {
                    confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",
                },
            });
            return false;
        }

        if (!message.trim()) {
            Swal.fire({
                imageUrl: Cancelar,
                imageWidth: 80,
                imageHeight: 80,
                title: 'Mensaje requerido',
                text: 'Por favor, ingresa el mensaje.',
                timer: 5000,
                timerProgressBar: true,
                showConfirmButton: true,
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#1F4F51',
                customClass: {
                    confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",
                },
            });
            return false;
        }
        return true;
    }



    const handleSendContact = async (e) => {
        e.preventDefault();

        if (handleValidation()) {
            setSendInfo(true)
            try {

                const sendData = {
                    "email": email,
                    "name": name,
                    "number": phone,
                    "message": message,
                }

                const response = await messageServices(sendData);


                Swal.fire({
                    icon: 'success',
                    title: 'Mensaje enviado',
                    text: 'Tu mensaje ha sido enviado exitosamente. ¡Gracias por contactarnos!',
                    timer: 5000,
                    timerProgressBar: true,
                    showConfirmButton: true,
                    confirmButtonText: 'Entendido',
                    confirmButtonColor: '#1F4F51',
                    customClass: {
                        confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",
                    },
                });
    
                // ✅ Limpiar los campos del formulario
                setName('');
                setEmail('');
                setPhone('');
                setMessage('');
                setSendInfo(false);

            } catch (error) {
                console.error("Error al enviar la data:", error);
            }
        }


    }

    return (
        <div >
            <Header />
            <div className="p-6 bg-white rounded-lg shadow max-w-2xl mx-auto mt-8 font-poppins">

                <h2 class="text-2xl font-bold text-center mb-4 text-primaryP">¡No dudes en comunicarte con nosotros en cualquier momento! Nos encantará saber de ti.</h2>

                <form class="max-w-sm mx-auto mt-5 mb-4" onSubmit={handleSendContact}>
                    <div class="mb-4">
                        <input type="text" id="name" value={name} onChange={(e) => { setName(e.target.value) }} placeholder='Nombre' class="bg-[#FBF3F0] border border-gray-300 text-gray-900 placeholder-zinc-950 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" required />
                    </div>
                    <div class="mb-4">
                        <input type="email" id="email" value={email} onChange={(e) => { setEmail(e.target.value) }} placeholder='Correo' class="bg-[#FBF3F0] border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" required />
                    </div>
                    <div class="mb-4">
                        <input type="number" id="phone" value={phone} onChange={(e) => { setPhone(e.target.value) }} placeholder='Teléfono' class="bg-[#FBF3F0] border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" required />
                    </div>
                    <div class="mb-4">
                        <textarea id="message" rows="4" value={message} onChange={(e) => { setMessage(e.target.value) }} placeholder='Mensaje' class="block p-2.5 w-full text-sm text-gray-900 bg-[#FBF3F0] rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500" required></textarea>
                    </div>
                    <div className="flex justify-center">
                        <button
                            type='submit'
                            class="text-white bg-[#1F4F51] focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-1/2 sm:w-auto px-5 py-2.5 text-center">
                            Enviar
                        </button>
                    </div>
                </form>

            </div>
            <Footer />
        </div>
    );
};

export default ContactForm;


